import { render, staticRenderFns } from "./PublishPopover.vue?vue&type=template&id=4f161e88&scoped=true&"
import script from "./PublishPopover.vue?vue&type=script&lang=js&"
export * from "./PublishPopover.vue?vue&type=script&lang=js&"
import style0 from "./PublishPopover.vue?vue&type=style&index=0&id=4f161e88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f161e88",
  null
  
)

export default component.exports